module.exports = __webpack_public_path__ + "fonts/fa-regular-400.4bf83cd6.ttf";